import React, {
  useEffect, useState, useCallback, useMemo,
} from 'react';
import MaterialTable, { MTableAction, MTableHeader } from 'material-table';
import { IconButton, Tooltip } from '@material-ui/core';
import { History } from '@material-ui/icons';

import MTableFilterRow from '../../../material-table-overrides/MTableFilterRow';
import { dtoRowToTable } from '../../../../dto/facts';
import { styledTableHeading, tableIcons } from '../../../../helpers';
import { localization, modifyDefaultOptions } from '../../../../helpers/table';
import useAPI from '../../../../hooks/useAPI';
import useUserContext from '../../../../hooks/useUserContext';
import { updateFactsRow } from '../../../../services/factsSvc';
import {
  isAdmin, isAdminRead, isAdminReadRestricted, isStratAdmin,
} from '../../../../services/rolesSvc';
import ToolbarWrapper from '../../../table/ToolbarWrapper';
import { getColumns, getFilterLookups } from './IndexTableViewHelper';
import KpiHistoryModal from '../../../../pages/index/KpiHistoryModal';
import {filterKpisByYear} from "../../../../pages/index/Shared";
import {Spinner} from "react-bootstrap";
import SpinnerComponent from "../../../SpinnerComponent/SpinnerComponent";

const factKpisType = 'Данные для расчета фактических значений по показателям';
const DEFAULT_YEAR = Number(DEFAULT_YEAR_WEBPACK);

export default function IndexTableView(props) {
  const api = useAPI();
  const userCtx = useUserContext();
  const [years, setYears] = useState([DEFAULT_YEAR]);
  const [originalData, setOriginalData] = useState([]);
  const [data, setData] = useState([]);
  const [filterLookups, setFilterLookups] = useState({});
  const [historyModalReport, setHistoryModalReport] = useState(null);
  const [allPeriodsKpi,setAllPeriodsKpi] = useState(null)

  data.sort((a, b) => {
    return Number(a.num.substr(1)) - Number(b.num.substr(1));
  });

  const fetchData = async () => {
    const result = await api.get(`/kpis/0/vals?type=${factKpisType}&typeFunding=${props.typeFunding}&strategyId=${props.strategyId}`)
    return result;
  }


  useMemo(() => {
    const newData = originalData.filter(k => filterKpisByYear(k, years)).map(dtoRowToTable);
    setData(newData);
    const newFilterLookups = getFilterLookups(newData);
    setFilterLookups(newFilterLookups);
  }, [originalData, years]);



  const closedYears = useMemo(()=>allPeriodsKpi?.filter(x=>x?.isClosed).map(x=>x.year),[allPeriodsKpi])

  const userPermissions = useMemo(() => ({
    canEdit: !!isAdminReadRestricted(userCtx),
    canEditRestricted: !!isAdmin(userCtx) || !!isStratAdmin(userCtx, props.strategyId),
    canEditStratKpiRoles: !!isAdmin(userCtx),
  }), [userCtx, props.strategyId]);

  useEffect( () => {
    fetchData().then((res)=>{
      if (res && !res.error) {
        setOriginalData(res)
      }
    }).then(async ()=>{
      const res = await api.get('/reports/periods/kpi')
      setAllPeriodsKpi(res)
    })
  }, [])

  const canEdit = true
  return (
    <div className="tab-index p2p-page">
        {!allPeriodsKpi ? <SpinnerComponent/> : <MaterialTable
        options={modifyDefaultOptions({
          draggable: false,
          search: false,
          maxBodyHeight: 'calc(100vh - 442px)',
          headerStyle: { height: 50 },
          filterCellStyle: {
            position: 'sticky',
            top: 50,
            background: 'white',
          },
        })}
        icons={tableIcons}
        localization={localization}
        columns={getColumns(years, userPermissions, filterLookups,closedYears)}
        data={data}
        title={<h3 style={styledTableHeading}>{props.header}</h3>}
        editable={{
          isEditable: () => userPermissions.canEditRestricted,
          onRowUpdate: !canEdit ? null :
            (newData) => new Promise(async (resolve, reject) => {
              const yearsOpenedForUpdate = years//.filter(y => isPeriodOpen(y));
              const updatedRow = await updateFactsRow(newData, yearsOpenedForUpdate, props.strategyId);
              await setData((prevState) =>
                prevState.map((e) =>
                  (e.id === newData.id ? { ...e, ...updatedRow, stratKpiRole: newData.stratKpiRole } : e)));
              resolve();
            }),
        }}
        actions={[
          {
            custom: true,
            hidden: false,
            icon: () => <History style={{ color: '#0D6EFD' }} />,
            tooltip: 'История изменений',
            onClick: (data) => {
              setHistoryModalReport({
                id: data.id, num: data.num, name: data.name, strategyId: props.strategyId,
              });
            },
          },
        ]}
        components={{
          FilterRow: (props) => (<MTableFilterRow {...props} />),
          Toolbar: (nativeProps) => (
            <ToolbarWrapper
              nativeProps={nativeProps}
              filters={{
                yearsProps: { selectedYears: years, onChange: setYears },
              }}
            />
          ),
          Action: (props) => {
            if (!props.action.custom) {
              return <MTableAction {...props} />;
            }
            const action = typeof props.action === 'function' ? props.action(props.data) : props.action;
            return (
              <Tooltip title={action.tooltip}>
                <IconButton onClick={() => action.onClick(props.data)} aria-label={action.tooltip} style={{ order: 2 }}>
                  <action.icon />
                </IconButton>
              </Tooltip>
            );
          },
        }}
      />}
      {historyModalReport && <KpiHistoryModal report={historyModalReport} onClose={() => setHistoryModalReport(null)} />}
    </div>
  );
}
